<template>
  <v-layout
    wrap
    class="mt-4"
  >
    <v-select
    v-model="category"
    :items="categories"
    label="Categories"
    solo
    class="mr-2"
    ></v-select>
    <v-text-field
      solo
      label="Store ID"
      v-model="store_id"
      @keyup.enter.prevent="search"
    >
      <template v-slot:append-outer>
        <v-btn large color="primary" style="margin-top: -10px" @click="search">Search</v-btn>
      </template>
    </v-text-field>
    <v-dialog
      v-model="dialog"
      persistent
      width="50%"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <div class="text-center py-3">
            <!-- {{count_done}} out of {{total}} -->
            {{count_done}}
          </div>
          <v-progress-linear
            color="white"
            class="mb-0"
            indeterminate
          ></v-progress-linear>
          <!-- <v-progress-linear
            color="white"
            class="mb-0"
            :value="count_done/total*100"
          ></v-progress-linear> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  components: {
  },
  props: [
    'searching',
    // 'total',
    'count_done'
  ],
  data () {
    return {
      store_id: '',
      dialog: this.searching,
      category: '',
      categories: ['toy_electronics', 'pets', 'patio_sports', 'office_art', 'health_personal_beauty', 'food', 'baby']
    }
  },
  methods: {
    search(){
      this.$emit('searchStarted', { store_id: this.store_id, category: this.category });
    }
  },
  watch: {
    searching: function(newVal, oldVal) {
      this.dialog = newVal;
    },
  },
};
</script>
